module.exports = __webpack_public_path__ + "img/magnifying-glass-plus.421e2b58.svg";